import React from 'react';
import { FormattedMessage } from 'react-intl';

const GalleryNoResultsComponent = (props) => {
  return (
    <FormattedMessage id="No images found." defaultMessage="No images found." />
  );
};

export default GalleryNoResultsComponent;
